export const sparConfig = {
  certPath: process.env.SPAR_CERTIFICATE_PATH,
  passphrase: process.env.SPAR_CERTIFICATE_PASSPHRASE,
  kundNr: '511959',
  orgNr: '165590980479',
  slutAnvandarId: 'VillviAB-170323',
  uppdragId: '39898',
  baseUrl: 'https://personsok.statenspersonadressregister.se/2021.1',
};
